<template>
   <v-layout align-center justify-end row fill-height>
     <v-tooltip bottom >
     <v-btn
        slot="activator"
        color="blue"
        icon
        small
        style="height: 23px;width: 23px;margin-right:5px!important"
        dark
        class="ma-0"
        @click="handleRefresh"
      >
       <v-icon style="font-size: 17px;">refresh</v-icon>
      </v-btn>
      <span>Atualizar</span>
     </v-tooltip>

      <v-btn
        slot="activator"
        color="teal"
        icon
        small
        style="height: 23px;width: 23px;"
        dark
        class="ma-0"
        @mousedown="scroll('left')"
        @mouseleave="stop" @mouseup="stop"
      >
       <v-icon style="font-size: 17px;">chevron_left</v-icon>
      </v-btn>

      <v-btn
      @mousedown.native="scroll('rigth')"
      @mouseleave="stop" @mouseup="stop"
        slot="activator"
        color="teal"
        icon
        small
        style="height: 23px;width: 23px;"
        dark
        class="ma-1"
      >
      <v-icon style="font-size: 17px;">chevron_right</v-icon>
      </v-btn>

    <!-- <v-tooltip top style="position: absolute;margin-top: -4px;margin-left: -41px;cursor: help;">
      <v-icon style="font-size: 13px;"  slot="activator" color="black">help</v-icon>
      <span>Movimentar a posição da tabela</span>
    </v-tooltip> -->
  </v-layout>
</template>

<script>
export default {
  props: ["component", "table"],
  data: () => ({
    interval: false,
    pos: 3,
    lastPos: null,
    soma: 0
  }),
  mounted: function() {
    this.$nextTick(function() {});
  },
  methods: {
    scroll(e) {
      if (!this.interval) {

        this.interval = setInterval(() => {
          if (this.lastPos == null) {
            var auxListaColunas = document.querySelector(
              "#table table tbody tr"
            ).childNodes;
            var listaColunas = [];
            auxListaColunas.forEach(element => {
              if (element.nodeName == "TD") {
                listaColunas.push(element);
              }
            });
            try {
              if (e == "left" && this.pos > 3) {
                this.pos--;
              }
              var content = document.querySelector("#table .v-table__overflow");
              var scrollX = listaColunas[this.pos].offsetWidth;
              

              if (e == "left") {
                scrollX = scrollX * -1;
              } else if (
                content.scrollLeft <
                content.scrollWidth - content.offsetWidth - 2
              ) {
                this.pos++;
              } else {
                this.lastPos == this.pos;
              }

              content.scrollBy(scrollX, 0);
            } catch (error) {
              throw new Error(
                "Erro ao tentar scrollar tabela usando botão" + error
              );
            }
          }
        }, 120);
      }
    },
    stop() {
      clearInterval(this.interval);
      this.interval = false;
    },
    handleRefresh() {
      // this.table.loading = true; 
      this.$store.commit('addUpdateTable', true);
      
    },
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/actionsHeader/btnMoverTable/BtnMoverTable.vue